import {FC, Fragment, ReactNode} from 'react';
import {DocumentDto} from '../../../../global/api';
import TableRow from '@mui/material/TableRow';
import DocIconSwitcher from '../../../../ui/doc-icon-switcher/DocIconSwitcher';
import {Chip, IconButton, Stack, styled, TableCell, Tooltip, Typography} from '@mui/material';
import {get} from 'lodash';
import {DateHelpers} from '../../../../shared/helpers/dateHelpers';
import {colors} from '../../../../shared/colors';
import EditIcon from '@mui/icons-material/Edit';
import DeleteForeverIcon from '@mui/icons-material/DeleteForever';
import {documentDeleteModalOpen} from '../../stores/contract-document-delete-modal.store';
import {documentUpdateModalOpen} from '../../stores/contract-document-update-modal.store';

const TYPE_LABEL_MAP = {
  SERVICE_REQUESTS: 'Заявки',
  OTHER: 'Другое',
} as const;

interface Props {
  document: DocumentDto;
  canEdit?: boolean;
}

export const ContractDocumentsTableRow: FC<Props> = ({document, canEdit = true}) => {
  const fileName = get(document, 'fileName', '');
  const description = get(document, 'description', '');
  const docTypeCode = get(document, 'docTypeCode', '');
  const documentId = get(document, 'id');

  const handleOpenDeleteModal = () => {
    if (!documentId) return;
    documentDeleteModalOpen(documentId);
  };

  const handleOpenUpdateModal = () => {
    if (!documentId) return;
    documentUpdateModalOpen({updatableId: documentId, fileName, description});
  };

  return (
    <Fragment>
      <TableRow>
        <TableCell width={24}>
          <DocIconSwitcher docName={fileName} />
        </TableCell>
        <StyledEllipsisTableCell>
          <Tooltip title={renderTooltipTitle(document)} placement="bottom">
            <StyledFileNameTypography>{fileName}</StyledFileNameTypography>
          </Tooltip>
        </StyledEllipsisTableCell>
        <TableCell width={100}>
          <Chip label={get(TYPE_LABEL_MAP, docTypeCode, TYPE_LABEL_MAP.OTHER)} variant="outlined" />
        </TableCell>
        <TableCell width={112}>
          <Stack direction="row" spacing={1}>
            <Tooltip title="Изменить название">
              <IconButton onClick={handleOpenUpdateModal} disabled={!canEdit}>
                <EditIcon color="primary" />
              </IconButton>
            </Tooltip>
            <Tooltip title="Удалить">
              <IconButton onClick={handleOpenDeleteModal} disabled={!canEdit}>
                <DeleteForeverIcon color="error" />
              </IconButton>
            </Tooltip>
          </Stack>
        </TableCell>
      </TableRow>
    </Fragment>
  );
};

function renderTooltipTitle(document: DocumentDto): ReactNode {
  return (
    <Fragment>
      <StyledTooltipTypography textOverflow="ellipsis">
        <b>Дата создания:</b> {DateHelpers.formatToRu(document?.createdDate)}
      </StyledTooltipTypography>
      <StyledTooltipTypography textOverflow="ellipsis">
        <b>Автор:</b> {get(document, 'createdFio', '-')}
      </StyledTooltipTypography>
      <StyledTooltipTypography textOverflow="ellipsis">
        <b>Комментарий:</b> {get(document, 'description', '-')}
      </StyledTooltipTypography>
    </Fragment>
  );
}

const StyledTooltipTypography = styled(Typography)({
  fontSize: '12px',
});

const StyledFileNameTypography = styled(Typography)({
  color: colors['icons--primary'],
  textDecoration: 'underline',
  cursor: 'pointer',
});

const StyledEllipsisTableCell = styled(TableCell)({
  overflow: 'hidden',
  textOverflow: 'ellipsis',
  maxWidth: 1,
});
